module.exports = __webpack_public_path__ + "img/hemo.bb92b712.jpg";